import axios from "@/plugins/axios";

let url = "/api/console/center/notifications";

export default {
    getNotifications(data){
        return axios.get(url, data).then(result => result.data);
    },
    getNotification(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    },
    postNotification(data){
        return axios.post(url, data).then(result => result.data);
    },
    putNotification(data){
        return axios.put(`${url}/${data._id}`, data).then(result => result.data);
    },
    deleteNotification(data){
        return axios.delete(`${url}/${data._id}`).then(result => result.data);
    }
}
